import { createFileRoute } from '@tanstack/react-router';
import { buildHead } from '../../utils/seo';

export const Route = createFileRoute('/_layout/privacy')({
  head: () => buildHead('/privacy'),
});

